import React, { Component } from 'react';
import {
    Router as Router,
    Route,
    Link,
    Switch,
    Redirect
  } from 'react-router-dom';
class ProjectComponent extends Component { 
    constructor(props) {
        super(props);
        this.state = {
            project: this.props.project,
            inputWidth: 50
        }
    }

    _handleInputName(e) {
        let name = e.target.value;

        this.setState(prevState => ({
            project: {
                ...prevState.project,
                name: name
            }
        }));

        this._resize();
    }

    _resize() {
        let nameLength = this.state.project.name.length <= 0 ? 2 : this.state.project.name.length;
        this.setState({inputWidth: (nameLength * 18)+ 'px'});
    }

    _handleUpdate(project) {

        this.props.updateProject(project);
    }

    _handleDelete() {
        this.props.deleteProject(this.state.project.id);
    }

    render() {
        let project = this.state.project;
        console.log(project);
        return(
            <li className="project" key={project.id}>
            <button className="project__btn  project__btn--delete" onClick={this._handleDelete.bind(this)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-delete"><path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line></svg>
            </button>
            <Link className="project__btn  project__btn--detail" to={`/projects/${project.id}`}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" class="feather feather-arrow-right-circle"><circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            </Link>
            <article>
                <input className="project__name" type="text" 
                        value={project.name}
                        onChange={this._handleInputName.bind(this)}
                        onBlur={this._handleUpdate.bind(this, this.state.project)}/>
            </article>
                
            </li>
        )
    }
}

export default ProjectComponent;


// WEBPACK FOOTER //
// src/components/project/project.component.js